import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import swal from 'sweetalert2';
import {TokenStorageService} from '../../../shared/service/token-storage.service';
import {Router} from '@angular/router';
import {ActionMode} from '../../../shared/enums/action-mode.enum';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {BorderModel} from '../../../shared/dto/border.model';
import {BorderService} from '../../../shared/service/border.service';
import {CountryModel} from '../../../model/country.model';
import {MatPaginator, MatTableDataSource} from '@angular/material';
import {MatSort} from '@angular/material/sort';

@Component({
  selector: 'app-boarder-popup',
  templateUrl: './boarder-popup.component.html',
  styleUrls: ['./boarder-popup.component.scss']
})
export class BoarderPopupComponent implements OnInit {

  @Input() designationMgtCopy_: BorderModel[];
  designationMgt: any;
  destinationPopup: FormGroup;
  public selectedState: string;
  ActionMode = ActionMode;
  public id: number;
  public name: string;
  public country: string;
  public addressLine1: string;
  public addressLine2: string;
  public addressLine3: string;
  public contactNo: number;
  public email: string;
  public fax: string;
  public status: string;
  public lastUpdatedUser: string;
  public url: string;
  public selectedMode;

  public designationDTO: BorderModel [] = [];
  public href: string = '';
  public countryList: CountryModel[] = [];
  dataSource: MatTableDataSource<any>;
  public dto: BorderModel[] = [];
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  constructor(public activeModal: NgbActiveModal,
              private borderService: BorderService,
              private tokenStorageService: TokenStorageService,
              private router: Router) {
  }

  ngOnInit() {
    this.destinationPopup = new FormGroup({
      id: new FormControl(null, Validators.required),
      name: new FormControl(null, Validators.required),
      country: new FormControl(null, Validators.required),
      addressLine1: new FormControl(null, Validators.required),
      addressLine2: new FormControl(null, Validators.required),
      addressLine3: new FormControl(null, Validators.required),
      contactNo: new FormControl(null, Validators.required),
      email: new FormControl(null, Validators.required),
      fax: new FormControl(null, Validators.required),
      status: new FormControl(null, Validators.required),
    });
    this.href = this.router.url;
    this.designationMgt = {...this.designationMgtCopy_};
    if (this.selectedMode === ActionMode.VIEW) {
      this.destinationPopup.disable();
    }
    this.loadAllCountries();
    status: [this.status]
  }

  onSubmit() {
    let isValid: boolean = true;
    let errorMessage: string = '';

    // if (!this.employeePopup.valid) {
    //   isValid = false;
    //   errorMessage = 'Please, Fill the form Data...!'
    // }
    if (isValid) {
      swal.fire({
        title: 'Are you sure, you want to submit?',
        text: '',
        showCancelButton: true,

        confirmButtonText: 'Yes'
      }).then((result) => {
          if (result.value) {
            const employeeDesignationDTO: BorderModel = new BorderModel(
              this.id,
              this.name,
              this.country,
              this.addressLine1,
              this.addressLine2,
              this.addressLine3,
              this.contactNo,
              this.email,
              this.fax,
              this.status,
              this.tokenStorageService.getUserObjectToken().username,
              this.href
            );
            this.borderService.saveBorderDetails(employeeDesignationDTO).subscribe(
              (success: string) => {
                swal.fire('Success', 'Details submitted successfully', 'success');
                this.getAllData();
              },
              (error) => {
                console.log(error);
                swal.fire('Sorry!', 'Something went wrong...!', 'error');
              },
              () => {
                this.activeModal.close('Saved');
              }
            );
          }
        }, reason => {
        }
      );
    } else {
      swal.fire('Error', errorMessage, 'error');
    }
  }

  loadAllCountries() {

    this.borderService.getAllCountries().subscribe(
      (data: CountryModel[]) => {
        this.countryList = data;
      }
    );
  }

  getAllData() {
    this.borderService.getAllBoderDetails().subscribe(
      (data: BorderModel[]) => {
        this.dto = data;
        this.dataSource = new MatTableDataSource(this.dto);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    )
  }

}
